export const getLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage;
};
